export default "__VITE_ASSET__CExXF6wx__"